import TradingDeskActionTypes from './tradingDeskV2-types'

export const startAccountDeposit = data => ({
    type: TradingDeskActionTypes.START_ACCOUNT_DEPOSIT,
    payload: data,
})
export const successAccountDeposit = data => ({
    type: TradingDeskActionTypes.SUCCESS_ACCOUNT_DEPOSIT,
    payload: data,
})
export const finishAccountDeposit = data => ({
    type: TradingDeskActionTypes.FINISH_ACCOUNT_DEPOSIT,
    payload: data,
})
export const failureAccountDeposit = data => ({
    type: TradingDeskActionTypes.FAILURE_ACCOUNT_DEPOSIT,
    payload: data,
})

export const startAccountWithdraw = data => ({
    type: TradingDeskActionTypes.START_ACCOUNT_WITHDRAW,
    payload: data,
})
export const successAccountWithdraw = data => ({
    type: TradingDeskActionTypes.SUCCESS_ACCOUNT_WITHDRAW,
    payload: data,
})
export const finishAccountWithdraw = data => ({
    type: TradingDeskActionTypes.FINISH_ACCOUNT_WITHDRAW,
    payload: data,
})
export const failureAccountWithdraw = data => ({
    type: TradingDeskActionTypes.FAILURE_ACCOUNT_WITHDRAW,
    payload: data,
})

export const startAddAccount = data => ({
    type: TradingDeskActionTypes.START_ADD_ACCOUNT,
    payload: data,
})
export const successAddAccount = data => ({
    type: TradingDeskActionTypes.SUCCESS_ADD_ACCOUNT,
    payload: data,
})
export const finishAddAccount = data => ({
    type: TradingDeskActionTypes.FINISH_ADD_ACCOUNT,
    payload: data,
})
export const failureAddAccount = data => ({
    type: TradingDeskActionTypes.FAILURE_ADD_ACCOUNT,
    payload: data,
})

export const startExchange = data => ({
    type: TradingDeskActionTypes.START_EXCHANGE,
    payload: data,
})
export const successExchange = data => ({
    type: TradingDeskActionTypes.SUCCESS_EXCHANGE,
    payload: data,
})
export const finishExchange = data => ({
    type: TradingDeskActionTypes.FINISH_EXCHANGE,
    payload: data,
})
export const failureExchange = data => ({
    type: TradingDeskActionTypes.FAILURE_EXCHANGE,
    payload: data,
})

export const startGetExchangeRate = data => ({
    type: TradingDeskActionTypes.START_GET_EXCHANGE_RATE,
    payload: data,
})
export const successGetExchangeRate = data => ({
    type: TradingDeskActionTypes.SUCCESS_GET_EXCHANGE_RATE,
    payload: data,
})
export const finishGetExchangeRate = data => ({
    type: TradingDeskActionTypes.FINISH_GET_EXCHANGE_RATE,
    payload: data,
})
export const failureGetExchangeRate = data => ({
    type: TradingDeskActionTypes.FAILURE_GET_EXCHANGE_RATE,
    payload: data,
})

export const startGetExchangeFee = data => ({
    type: TradingDeskActionTypes.START_GET_EXCHANGE_FEE,
    payload: data,
})
export const successGetExchangeFee = data => ({
    type: TradingDeskActionTypes.SUCCESS_GET_EXCHANGE_FEE,
    payload: data,
})
export const finishGetExchangeFee = data => ({
    type: TradingDeskActionTypes.FINISH_GET_EXCHANGE_FEE,
    payload: data,
})
export const failureGetExchangeFee = data => ({
    type: TradingDeskActionTypes.FAILURE_GET_EXCHANGE_FEE,
    payload: data,
})

/************************ Start Max Fees ***************************/

export const startMaxFees = data => ({
    type: TradingDeskActionTypes.START_MAX_FEES_V2,
    payload: data,
})

export const successMaxFees = data => ({
    type: TradingDeskActionTypes.SUCCESS_MAX_FEES_V2,
    payload: data,
})

export const finishMaxFees = data => ({
    type: TradingDeskActionTypes.FINISH_MAX_FEES_V2,
    payload: data,
})

export const failureMaxFees = data => ({
    type: TradingDeskActionTypes.FAILURE_MAX_FEES_V2,
    payload: data,
})
